export const ObtenerDirecciones = () => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/direcciones.php?funcion=direcciones',{
            method:'POST',
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const GuardarDireccion = (direccion) => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/direcciones.php?funcion=agregarDireccion',{
            method:'POST',
            body:JSON.stringify(direccion)
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}